export default {
    title: "Nutzer verknüpfen",
    user: 'Nutzer',
    role: 'Rolle',
    attachUser: 'Nutzer verknüpfen',
    attachUserSuccess: 'Der Nutzer wurde erfolgreich verknüpft.',
    attachUserError: 'Der Nutzer konnte nicht verknüpft werden.'
}